import { useEffect } from 'react'
import { showCookieBanner } from '@guestgoodie/cookie-consent'
import { useLingui } from '@lingui/react/macro'

export default function CookieBanner() {
  const { t, i18n } = useLingui()

  useEffect(() => {
    showCookieBanner({
      gtagEnabled: false,
      clarityEnabled: false,
      translations: {
        consentModal: {
          title: t`We Value Your Privacy`,
          description: t`We use cookies to enhance your browsing experience and improve our services. Some cookies are essential for the website to function properly, while others help us improve our offerings.`,
          acceptAllBtn: t`Accept All`,
          acceptNecessaryBtn: t`Reject All`,
          showPreferencesBtn: t`Manage Preferences`,
          imprint: t`Legal Notice`,
          privacy: t`Privacy Policy`,
          imprint_url: `/${i18n.locale}/imprint`,
          privacy_url: `/${i18n.locale}/privacy`
        },
        preferencesModal: {
          title: t`Cookie Preferences`,
          acceptAllBtn: t`Accept All`,
          acceptNecessaryBtn: t`Reject All`,
          savePreferencesBtn: t`Save Preferences`,
          closeIconLabel: t`Close Window`,
          info: {
            title: t`About Cookies`,
            description: t`Cookies help us provide you with the best possible experience. Please choose which types of cookies you'd like to allow.`
          },
          necessary: {
            title: t`Essential Cookies`,
            description: t`These cookies are essential for the website to function properly and cannot be disabled. They don't store any personal data and are only used on this website.`
          },
          analytics: {
            title: t`Analytics & Performance`,
            description: t`These cookies help us understand and improve how visitors use our website. All data is collected anonymously and cannot be used to identify individual users.`
          },
          more: {
            title: t`More Information`,
            description: t`For any questions about our cookie policy and your choices, please reach out through <a href="mailto:privacy@guestgoodie.com">privacy@guestgoodie.com</a>.`
          }
        }
      }
    })
  }, [t, i18n])

  return null
}
